module.exports = __webpack_public_path__ + "img/avi.cafab79c.svg";